import { getAxiosInstance } from "./axiosInstance";

const createVehicleMake = (data) => {
    const http = getAxiosInstance();
    return http.post("/api/Settings/create_settings_VehicleMake/", data);
};

const deleteVehicleMake = (id) => {
    const http = getAxiosInstance();

    return http.delete(
        `/api/Settings/delete_settings_VehicleMake/${id}/`,
        {
            headers: {
                Authorization: http.defaults.headers.Authorization,
                "Content-Type": "application/json",
            },
        }
    );
};

const createVehicleModel = (data) => {
    const http = getAxiosInstance();
    return http.post("/api/Settings/create_settings_VehicleModel/", data);
};

const deleteVehicleModel = (id) => {
    const http = getAxiosInstance();
    return http.delete(`/api/Settings/delete_settings_VehicleModel/${id}/`);
};

// Public API
const getVehicleMakeList = (makeId = "") => {
    const http = getAxiosInstance();

    const url = makeId
        ? `/api/pub/Settings/list_settings_VehicleMake_pub/?make_id=${makeId}`
        : "/api/pub/Settings/list_settings_VehicleMake_pub/";

    return http.get(url);
};

const getVehicleModel = (makeId) => {
    const http = getAxiosInstance();

    return http.get(
        `/api/pub/Settings/list_settings_VehicleMake_pub/?make_id=${makeId}`
    );
};

const VehiclesServices = {
    createVehicleMake,
    deleteVehicleMake,
    createVehicleModel,
    deleteVehicleModel,
    getVehicleMakeList,
    getVehicleModel,
};

export default VehiclesServices;